import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import NewsCategories from './components/NewsCategories';
import RewardsSection from './components/RewardsSection';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import DownloadCTA from './components/DownloadCTA';
import Footer from './components/Footer';

const Landing = () => (
  <div className="App">
    <Navbar />
    <main>
      <Hero />
      <NewsCategories />
      <RewardsSection />
      <HowItWorks />
      <Testimonials />
      <DownloadCTA />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
